/**
 * Normalize a URI by ensuring it starts with a forward slash and is a valid URL.
 * For example:
 *
 * normalizeUri("https://www.google.com/test") => "/test"
 * normalizeUri("/test") => "/test"
 * normalizeUri("test") => "/test"
 *
 * @param uri - The URI to normalize.
 * @returns The normalized URI.
 */
export const normalizeUri = (uri: string): string => {
  let resultPath: string;

  try {
    // Attempt to parse as a full URL
    const url = new URL(uri);
    resultPath = url.pathname;
  } catch (error) {
    // If parsing fails, assume it might be a relative path already
    // console.warn(`normalizeUri failed for input: ${uri}, treating as path.`, error);
    resultPath = uri;
  }

  // Ensure the result always starts with a forward slash
  if (!resultPath.startsWith("/")) {
    resultPath = "/" + resultPath;
  }

  return resultPath;
};
